import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-category-tab',
  templateUrl: './category-tab.component.html',
  styleUrls: ['./category-tab.component.scss']
})
export class CategoryTabComponent implements OnInit {
  @Input() categories: any = [];
  @Input() activeTab: any = null;
  @Output() changeTab: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const query = this.route.snapshot.queryParams;
    const { category_id } = query;
    let tabId = this.categories[0].id;
    if(category_id !== undefined) {
      if(this.categories.some((category: any) => category.id == category_id)) {
        tabId = Number(category_id);
      }
    }
    this.onClickTab({ id: tabId });
    setTimeout(() => {
      this.scrollToTab(tabId);
    }, 300);
  }

  scrollToTab(tabId: any) {
    const tab = document.getElementById(tabId);
    const container = tab.parentElement;
    if(tab && container) {
      const left = tab.offsetLeft - container.offsetLeft;
      container.scrollTo({ left, behavior: 'smooth' });
    }
  }
      

  onClickTab(tab: any) {
    if(tab.id !== this.activeTab) {
      this.activeTab = tab.id;
      this.changeTab.emit(tab.id);
    }
  }

}
